module.exports = __webpack_public_path__ + "static/media/music-instruments.b5fe18fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/music-instruments.svg
// module id = 3064
// module chunks = 0